// Helpers for keeping a Location (or any non-program) from standing in as an enrollment's program.
import { useNotificationStore } from '@/stores/notification';

// Keeps only encounters whose program was returned as a HealthcareService.
export function withResolvableProgram(encounters, healthcareServices) {
    const programIds = new Set(healthcareServices.map((hs) => hs.id));
    return encounters.filter((encounter) => encounter.healthcareService?.id && programIds.has(encounter.healthcareService.id));
}

// Keeps only encounters whose episode of care was returned; warns on each one dropped so the bad data is findable.
export function withResolvableEpisode(encounters, episodesOfCare) {
    const episodeIds = new Set(episodesOfCare.map((eoc) => eoc.id));
    return encounters.filter((encounter) => {
        if (encounter.episodeOfCare?.some((eoc) => episodeIds.has(eoc.id))) return true;
        console.warn(`Skipping program enrollment Encounter/${encounter.id}: its episode of care could not be found`);
        return false;
    });
}

// The default program when it is an active program at the location, otherwise the first one that is.
export function pickInitialProgram(items, locationId, defaultProgramId) {
    const programs = items.filter((item) => item.resourceType === 'HealthcareService' && item.active && item.location?.some((loc) => loc.id === locationId));
    return programs.find((item) => item.id === defaultProgramId) || programs[0];
}

// 'A', 'A and B', 'A, B and C'
const joinNames = function (names) {
    if (names.length < 2) return names.join('');
    return names.slice(0, -1).join(', ') + ' and ' + names[names.length - 1];
};

// Why nothing was charted for a contact with no active program enrollment.
// names is one name or a list; outcome null drops the ", so ..." clause; options.lead opens the message
// as its own sentence; options.nextStep replaces the default next step, and false leaves it out.
export function noActiveProgramMessage(contactName, outcome = 'no form was added', options = {}) {
    const names = Array.isArray(contactName) ? contactName : [contactName];
    const verb = names.length > 1 ? 'have' : 'has';
    const nextStep = options.nextStep === undefined ? 'Enroll them in a program first.' : options.nextStep;
    let message = `${joinNames(names)} ${verb} no active program enrollment`;
    message += outcome === null ? '.' : `, so ${outcome}.`;
    if (options.lead) message = `${options.lead} ${message}`;
    if (nextStep) message += ` ${nextStep}`;
    return message;
}

// Shows that message until the user closes it.
export function notifyNoActiveProgram(contactName, outcome, options) {
    useNotificationStore().add({ color: 'warning', timeout: -1, message: noActiveProgramMessage(contactName, outcome, options) });
}
